import { ProgressState, SurveyResponseState } from "../../../store/StateControllers/Survey/SurveyResponse/SurveyResponseStates";
import { ToxnotComponentProperties } from "../../core/BaseApplicationComponents/ToxnotComponent";
import * as SurveyResponseController from "../../../store/StateControllers/Survey/SurveyResponse/SurveyResponseController";

import "./styles.css";
import { ToxnotSignInRequiredComponent } from "../../core/BaseApplicationComponents/ToxnotSignInRequiredComponent";
import { TeamRole } from "../../../store/Models/UserContext";
import { ApplicationState } from "../../../store";
import { connect } from "react-redux";

type SurveyResponseComponentProperties = 
    ProgressState & 
    ToxnotComponentProperties & 
    SurveyResponseState & 
    typeof SurveyResponseController.actionCreators;

class SurveyResponseProgress extends ToxnotSignInRequiredComponent<SurveyResponseComponentProperties> {

    protected getDisallowedRoles(): TeamRole[] {
        return [TeamRole.Marketing, TeamRole.Viewer];
    }

    protected renderConcreteComponent(): JSX.Element | null {
        const { title, current, currentInventoryId, next, maxProgress, currentProgress } = this.props;

        let progressWidth = `${maxProgress === 0 ? 0 : (currentProgress / maxProgress) * 100}%`;


        return (
            <div className="tn-section survey-response-progress-wrapper">
                <div className="row">
                    <div className="col-xs-6">
                        <h4 className="m-b-10 m-t-10">
                            {this.localizeString("Digital Product Passport")}
                        </h4>
                    </div>
                    <div className="col-xs-6">
                        <div className="progress-bar-wrapper">
                            <div className="progress m-b-5">
                                <div
                                    style={{ width: progressWidth }}
                                    className="progress-bar progress-bar-success"
                                    role="progressbar"
                                    aria-valuenow={currentProgress}
                                    aria-valuemin={0}
                                    aria-valuemax={maxProgress}
                                ></div>
                            </div>
                        </div>
                        <div className="progress-steps">
                            <span className="progress-current-step">
                                {this.localizeString(current)}
                            </span>
                            {next && (
                                <>
                                    <span>&nbsp;&gt;&gt;&nbsp;</span>
                                    <span title={this.localizeString(next)} className="progress-next-step">
                                        <i>{this.localizeString(next)}</i>
                                    </span>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state: ApplicationState) => ({ ...state.surveyResponseState, appServices: state.appServices }),
    SurveyResponseController.actionCreators
)(SurveyResponseProgress as any);